<template>
 <svg :style="style" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame" clip-path="url(#clip0_4253_85388)">
<path id="Vector" d="M10.7391 8.78001C10.7391 8.78001 10.8437 13.2502 12.5298 14.6791C12.8621 14.9622 13.0541 15.3474 13.0541 15.7548V30.1425H19.1108V15.8446C19.1108 15.1591 19.384 14.4932 19.8898 13.9739C21.4332 12.3886 23.1132 8.34062 23.6068 7.09385C23.6855 6.89693 23.5526 6.68154 23.3212 6.63478C22.6381 6.49324 21.9292 6.74924 21.5538 7.27354L19.9415 9.52216C19.5095 9.5037 18.7009 9.67847 18.7009 9.67847L20.7095 2.45016C20.8535 1.93324 20.4954 1.41262 19.912 1.28708C19.3274 1.16031 18.7378 1.47539 18.5951 1.99108L16.984 7.78062V1.23662C16.984 0.70616 16.4966 0.275391 15.8948 0.275391C15.2941 0.275391 14.8068 0.70616 14.8068 1.23662V7.78062L13.3409 2.50308C13.1969 1.98616 12.6074 1.67231 12.024 1.79785C11.4394 1.92462 11.0824 2.44524 11.2252 2.96093L12.6701 8.16093L10.6591 4.66554C10.44 4.24708 9.87998 4.06616 9.40737 4.25939C8.93598 4.45139 8.73044 4.94616 8.94829 5.36339L10.7391 8.78001Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_4253_85388">
<rect width="32" height="32" fill="white" transform="translate(0 0.275391)"/>
</clipPath>
</defs>
</svg>


</template>

<script>
export default {
  name: 'icon-qbjb',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>